import React from 'react';
import { CMSContent } from '../components/cms/CMSContent';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-testid="terms-page">
      <SEO
        title="Terms of Service"
        description="TreatX Terms of Service — the binding agreement governing use of the TreatX platform for patients and providers."
        canonicalPath="/terms"
      />
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm p-6 sm:p-8 lg:p-10">
        <CMSContent
          contentKey="terms_of_service"
          showTitle={true}
          showSummary={false}
          showLegalMetadata={true}
        />
      </div>
    </div>
  );
};

export default TermsPage;
